
import './App.css';
import React, { useEffect, useRef, useState } from 'react';

import {  login, password } from './config';
import { useLoggedUser } from './store/useLoggedUser';


import {
  createHashRouter,
  RouterProvider,
} from "react-router-dom";
import { LoginForm } from './components/LoginForm';
import ChatApp from './ChatApp';
import { RegisteredDoctorsApp } from './RegisteredDoctorsApp';


const router = createHashRouter([
  {path:'/', element: <ChatApp/>},
  {path:'/doctors', element: <RegisteredDoctorsApp/>},
  //{path:'/przewodnik/en', element: <AudioGuideApp lang="EN"/>}
])



function App() {

  const user = useLoggedUser()

  useEffect(()=>{

    /*
    if(!user.logged){
      user.logUserIn(login,password).then(
        //result => rooms.load() 
      )
    }
    */

  },[])

  return !user.logged 
    ? <div className="App"><LoginForm></LoginForm></div>
    : <RouterProvider router={router} ></RouterProvider>
  
}

export {App};
